import { OptionDto } from "@/dtos";
import { DeviceRechargeType } from "@/helpers/types";

const deviceDeviceRechargeTypes = [
    { value: DeviceRechargeType.CREDIT, label: 'Crédito' },
    { value: DeviceRechargeType.DEBIT, label: 'Débito' },
] as OptionDto[];

export const getDeviceRechargeTypeOptions = (): OptionDto[] => {
    return deviceDeviceRechargeTypes;
}

export const getDeviceRechargeTypeOption = (value?: number): OptionDto => {
    return deviceDeviceRechargeTypes.find((x) => x.value == value) ?? deviceDeviceRechargeTypes[0];
}

export const getDeviceRechargeTypeLabel = (value: number): string => {
    return deviceDeviceRechargeTypes.find((x) => x.value == value)?.label ?? deviceDeviceRechargeTypes[0].label;
}